import { ArrowLeft, MessageCircle } from "lucide-react";
import { useExplorer } from "@/context/ExplorerContext";
import { waLink } from "@/config";

// French text printed on the product, isolated for bidi safety.
export const Fr = ({ children, className = "", ...rest }) => (
  <bdi lang="fr" dir="ltr" className={`font-latin ${className}`} {...rest}>
    {children}
  </bdi>
);

// label/subLabel override the site-wide t.cta/t.ctaSub text for this one button, e.g. a section that needs its own wording.
export const CTA = ({ testId = "cta-button", className = "", compact = false, href = "#commander", label, subLabel }) => {
  const { t } = useExplorer();
  return (
    <a
      href={href}
      data-testid={testId}
      className={`group inline-flex min-h-[52px] items-center gap-3 rounded-full bg-coral px-6 py-3 text-cream shadow-[0_10px_24px_-10px_rgba(238,108,77,0.7)] transition-[background-color,transform,box-shadow] duration-300 hover:-translate-y-0.5 hover:bg-coral-deep hover:shadow-[0_16px_30px_-10px_rgba(238,108,77,0.8)] focus:outline-none focus-visible:ring-4 focus-visible:ring-coral/30 ${className}`}
    >
      <span className="flex flex-col items-start text-start leading-tight">
        <span className="text-[1.05rem] font-bold">{label ?? t.cta}</span>
        {!compact && <span className="text-[0.8rem] font-medium opacity-90">{subLabel ?? t.ctaSub}</span>}
      </span>
      <ArrowLeft size={18} className="transition-transform duration-300 group-hover:-translate-x-1 rtl:block ltr:rotate-180 ltr:group-hover:translate-x-1" />
    </a>
  );
};

export const WhatsAppButton = ({ testId = "whatsapp-order-button", className = "", label, message }) => (
  <a
    href={waLink(message)}
    target="_blank"
    rel="noreferrer"
    data-testid={testId}
    className={`inline-flex min-h-[52px] items-center justify-center gap-2 rounded-full border-2 border-[#25D366]/70 bg-cream-card px-5 py-3 text-[1rem] font-bold text-ink transition-[background-color,transform] duration-300 hover:-translate-y-0.5 hover:bg-[#25D366]/10 ${className}`}
  >
    <MessageCircle size={18} className="text-[#25D366]" />
    {label}
  </a>
);

export const Eyebrow = ({ children, className = "", tone = "text-blue" }) => <p className={`eyebrow ${tone} ${className}`}>{children}</p>;

export const Hand = ({ children, className = "", tone = "text-coral", rotate = -2, ...rest }) => (
  <span className={`font-hand ${tone} ${className}`} style={{ display: "inline-block", transform: `rotate(${rotate}deg)` }} {...rest}>
    {children}
  </span>
);

export const Tape = ({ className = "" }) => <span aria-hidden className={`tape ${className}`} />;

export const Section = ({ id, children, className = "", bg = "" }) => (
  <section id={id} data-testid={`section-${id}`} className={`relative px-5 py-20 sm:px-8 sm:py-28 lg:px-12 lg:py-32 ${bg} ${className}`}>
    <div className="mx-auto w-full max-w-6xl">{children}</div>
  </section>
);
